export const runOnce = (
  id: string,
  fn: () => void,
  options: {
    storage: "localStorage" | "sessionStorage";
  },
) => {
  const runOnceKey = `_RUN_ONCE_${id}`;
  const storage = options?.storage || "localStorage";
  const storageInstance =
    storage === "localStorage" ? localStorage : sessionStorage;

  const hasRunOnce = storageInstance.getItem(runOnceKey) === "true";
  if (hasRunOnce) return false;
  storageInstance.setItem(runOnceKey, "true");
  fn();
  return true;
};
